import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["items", "value", "itemCaptionExtractor", "filter", "onFetchRequested", "onClearRequested", "ItemComponent", "showWithEmptyValue", "showEmptyList", "EmptyListComponent", "showPending", "PendingComponent"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { debounce } from 'debounce';
import TextInput from "./index";
import styles from "./AutocompleteInput.pcss";
var cx = classNames.bind(styles);
function defaultStringFilter(item) {
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return item && item.toLowerCase().startsWith(value.toLowerCase());
}

/**
 * Поле ввода с автодополнением.
 */
var AutocompleteInput = /*#__PURE__*/function (_Component) {
  _inherits(AutocompleteInput, _Component);
  var _super = _createSuper(AutocompleteInput);
  function AutocompleteInput(props) {
    var _this;
    _classCallCheck(this, AutocompleteInput);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "getValueCaption", function (value) {
      if (value) {
        return _this.props.itemCaptionExtractor(value);
      }
      return value;
    });
    _defineProperty(_assertThisInitialized(_this), "getItemComponent", function () {
      if (_this.props.ItemComponent) return _this.props.ItemComponent;
      return function (_ref) {
        var value = _ref.value;
        return /*#__PURE__*/React.createElement("div", {
          className: cx('item'),
          "data-t-id": "components-TextInput"
        }, _this.props.itemCaptionExtractor(value));
      };
    });
    _defineProperty(_assertThisInitialized(_this), "handleInputChange", debounce(function (value) {
      _this.fetchRequest(value);
    }, 300));
    _defineProperty(_assertThisInitialized(_this), "handleFocus", function () {
      _this.setState({
        focus: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (event) {
      var _this$state = _this.state,
        activeItemIndex = _this$state.activeItemIndex,
        filteredItems = _this$state.filteredItems,
        focus = _this$state.focus;
      if (['ArrowDown', 'ArrowUp', 'Enter'].indexOf(event.key) === -1) {
        return;
      }
      event.preventDefault();
      if (event.key === 'ArrowDown') {
        var newIndex;
        if (activeItemIndex === null || !focus) {
          newIndex = 0;
        } else if (activeItemIndex < filteredItems.length - 1) {
          newIndex = activeItemIndex + 1;
        } else {
          newIndex = filteredItems.length - 1;
        }
        _this.setState({
          activeItemIndex: newIndex,
          focus: true
        });
      } else if (event.key === 'ArrowUp') {
        var _newIndex = activeItemIndex - 1 >= 0 ? activeItemIndex - 1 : 0;
        _this.setState({
          activeItemIndex: _newIndex
        });
      } else if (event.key === 'Enter' && activeItemIndex >= 0) {
        _this.selectItem(filteredItems[activeItemIndex]);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleGetRef", function (inputRef) {
      _this.setState({
        inputRef: inputRef
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleOuterClick", function (event) {
      if (event.target !== _this.state.inputRef && _this.state.focus) {
        _this.setState({
          focus: false
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleClear", function () {
      _this.setState({
        filterValue: ''
      });
      if (_this.props.onClearRequested) {
        _this.props.onClearRequested();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "selectItem", function (item) {
      var filterValue = _this.props.itemCaptionExtractor(item);
      _this.setState({
        value: item,
        filterValue: filterValue,
        filteredItems: _this.props.filter(filterValue, _this.props.items),
        activeItemIndex: null,
        focus: false
      }, function () {
        if (_this.props.onChange) {
          _this.props.onChange(item);
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "excludeOwnProps", function () {
      // Исключаем собственные props, чтобы не передавать их в TextInput
      var _this$props = _this.props,
        items = _this$props.items,
        value = _this$props.value,
        itemCaptionExtractor = _this$props.itemCaptionExtractor,
        filter = _this$props.filter,
        onFetchRequested = _this$props.onFetchRequested,
        onClearRequested = _this$props.onClearRequested,
        ItemComponent = _this$props.ItemComponent,
        showWithEmptyValue = _this$props.showWithEmptyValue,
        showEmptyList = _this$props.showEmptyList,
        EmptyListComponent = _this$props.EmptyListComponent,
        showPending = _this$props.showPending,
        PendingComponent = _this$props.PendingComponent,
        inputProps = _objectWithoutProperties(_this$props, _excluded);
      return inputProps;
    });
    _this.state = {
      value: _this.props.value,
      focus: false,
      activeItemIndex: null,
      filterValue: _this.getValueCaption(_this.props.value),
      filteredItems: _this.props.items,
      inputRef: null,
      isPending: false
    };
    return _this;
  }
  _createClass(AutocompleteInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('click', this.handleOuterClick);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var filterValue = this.state.filterValue || '';
      if (nextProps.value !== this.props.value) {
        filterValue = this.getValueCaption(nextProps.value);
        this.setState({
          value: nextProps.value,
          filterValue: filterValue
        });
      }
      this.setState({
        filteredItems: nextProps.filter(filterValue, nextProps.items),
        activeItemIndex: null,
        isPending: false
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleOuterClick);
    }
  }, {
    key: "fetchRequest",
    value: function fetchRequest(value) {
      if (this.props.onFetchRequested) {
        this.props.onFetchRequested(value);
        if (this.props.showPending) {
          this.setState({
            isPending: true
          });
        }
      }
      this.setState({
        filterValue: value,
        filteredItems: this.props.filter(value, this.props.items),
        activeItemIndex: null,
        focus: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var className = this.props.className;
      var opened = !!(this.state.focus && (this.props.showWithEmptyValue || this.state.filterValue));
      return /*#__PURE__*/React.createElement("div", {
        className: cx('autocompleteInput')
      }, /*#__PURE__*/React.createElement(TextInput, _extends({}, this.excludeOwnProps(), {
        autoComplete: "off",
        className: cx(className, {
          inputOpened: opened
        }),
        clearable: true,
        getRef: this.handleGetRef,
        onChange: this.handleInputChange,
        onClear: this.handleClear,
        onFocus: this.handleFocus,
        onKeyDown: this.handleKeyDown,
        value: this.state.filterValue
      })), /*#__PURE__*/React.createElement(AutocompleteList, {
        EmptyListComponent: this.props.EmptyListComponent,
        ItemComponent: this.getItemComponent(),
        PendingComponent: this.props.PendingComponent,
        activeItemIndex: this.state.activeItemIndex,
        isPending: this.props.showPending && this.state.isPending,
        items: this.state.filteredItems,
        onItemClick: function onItemClick(event, item) {
          return _this2.selectItem(item);
        },
        opened: opened,
        showEmptyList: this.props.showEmptyList
      }));
    }
  }]);
  return AutocompleteInput;
}(Component);
_defineProperty(AutocompleteInput, "defaultProps", {
  items: [],
  value: null,
  itemCaptionExtractor: function itemCaptionExtractor(value) {
    return value.toString();
  },
  filter: function filter(value, items) {
    return items.filter(function (item) {
      return defaultStringFilter(item, value);
    });
  },
  ItemComponent: null,
  onChange: null,
  onFetchRequested: null,
  onClearRequested: null,
  showWithEmptyValue: false,
  showEmptyList: false,
  EmptyListComponent: undefined,
  showPending: false,
  PendingComponent: undefined
});
export { AutocompleteInput as default };
AutocompleteInput.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Массив объектов для автодополнения.
   */
  items: PropTypes.array,
  /**
   * Значение по умолчанию.
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /**
   * Функция для получения отображаемого текста для объектов.
   */
  itemCaptionExtractor: PropTypes.func,
  /**
   * Функция фильтрации объектов.
   */
  filter: PropTypes.func,
  /**
   * Обработчик изменения значения.
   */
  onChange: PropTypes.func,
  /**
   * Обработчик запроса получения данных. Обработчик всегда должен
   * обновлять props.items, т.к. состояние isPending сбрасывается
   * при обновлении props.
   */
  onFetchRequested: PropTypes.func,
  /**
   * Обработчик очистки поля.
   */
  onClearRequested: PropTypes.func,
  /**
   * Компонент для отображения значения в выпадающем списке.
   */
  ItemComponent: PropTypes.func,
  /**
   * Признак, определяющий, показывать ли доступные значения при пустом
   * значении в поле.
   */
  showWithEmptyValue: PropTypes.bool,
  /**
   * Признак, определяющий, показывать ли компонент при пустом списке.
   */
  showEmptyList: PropTypes.bool,
  /**
   * Компонент для пустого значения
   */
  EmptyListComponent: PropTypes.func,
  /**
   * Признак, определяющий, показывать ли компонент для загрузки списка.
   */
  showPending: PropTypes.bool,
  /**
   * Компонент для отображения загрузки списка.
   */
  PendingComponent: PropTypes.func,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
} : {};
var AutocompleteList = /*#__PURE__*/function (_Component2) {
  _inherits(AutocompleteList, _Component2);
  var _super2 = _createSuper(AutocompleteList);
  function AutocompleteList() {
    var _this3;
    _classCallCheck(this, AutocompleteList);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this3 = _super2.call.apply(_super2, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this3), "handleClick", function (event, item) {
      if (_this3.props.onItemClick) {
        _this3.props.onItemClick(event, item);
      }
    });
    return _this3;
  }
  _createClass(AutocompleteList, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.container && this.activeRef) {
        var containerRect = this.container.getBoundingClientRect();
        var activeItemRect = this.activeRef.getBoundingClientRect();
        if (activeItemRect.bottom > containerRect.bottom) {
          this.container.scrollTop += activeItemRect.height;
        }
        if (activeItemRect.top < containerRect.top) {
          this.container.scrollTop -= activeItemRect.height;
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props2 = this.props,
        opened = _this$props2.opened,
        items = _this$props2.items,
        ItemComponent = _this$props2.ItemComponent,
        activeItemIndex = _this$props2.activeItemIndex,
        showEmptyList = _this$props2.showEmptyList,
        EmptyListComponent = _this$props2.EmptyListComponent,
        isPending = _this$props2.isPending,
        PendingComponent = _this$props2.PendingComponent;
      if (!opened) return null;
      if (isPending) {
        return /*#__PURE__*/React.createElement("div", {
          className: cx('autocompleteList')
        }, /*#__PURE__*/React.createElement(PendingComponent, null));
      }
      this.activeRef = null;
      return /*#__PURE__*/React.createElement("div", {
        className: cx('autocompleteList'),
        ref: function ref(container) {
          _this4.container = container;
        }
      }, items.length > 0 ? items.map(function (item, index) {
        var isActive = activeItemIndex >= 0 && index === activeItemIndex;
        return /*#__PURE__*/React.createElement("div", {
          className: cx('itemWrapper', {
            active: isActive
          }),
          key: index,
          onClick: function onClick(event) {
            return _this4.handleClick(event, item);
          },
          ref: function ref(el) {
            if (isActive) _this4.activeRef = el;
          },
          role: "listitem"
        }, /*#__PURE__*/React.createElement(ItemComponent, {
          isActive: isActive,
          value: item
        }));
      }) : showEmptyList && /*#__PURE__*/React.createElement(EmptyListComponent, null));
    }
  }]);
  return AutocompleteList;
}(Component);
_defineProperty(AutocompleteList, "defaultProps", {
  opened: false,
  items: [],
  ItemComponent: function ItemComponent(_ref2) {
    var value = _ref2.value;
    return /*#__PURE__*/React.createElement("span", null, value);
  },
  activeItemIndex: null,
  onItemClick: null,
  showEmptyList: false,
  EmptyListComponent: function EmptyListComponent() {
    return /*#__PURE__*/React.createElement("div", {
      className: cx('emptyList')
    }, "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E");
  },
  isPending: false,
  PendingComponent: function PendingComponent() {
    return /*#__PURE__*/React.createElement("div", {
      className: cx('emptyList')
    }, "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...");
  }
});
AutocompleteList.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Признак, определяющий, раскрыт ли список.
   */
  opened: PropTypes.bool,
  /**
   * Массив объектов для отображения в выпадающем списке.
   */
  items: PropTypes.array,
  /**
   * Компонент для отображения значения в выпадающем списке.
   */
  ItemComponent: PropTypes.func,
  /**
   * Индекс текущего активного элемента.
   */
  activeItemIndex: PropTypes.number,
  /**
   * Действие при клике по значению.
   */
  onItemClick: PropTypes.func,
  /**
   * Признак, определяющий, показывать ли компонент при пустом списке.
   */
  showEmptyList: PropTypes.bool,
  /**
   * Компонент для пустого значения
   */
  EmptyListComponent: PropTypes.func,
  /**
   * Признак выполнения загрузки.
   */
  isPending: PropTypes.bool,
  /**
   * Компонент для отображения загрузки списка.
   */
  PendingComponent: PropTypes.func
} : {};